/*
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview Bouton central de l'interface
 */
(function($g, createjs) {
    "use strict";
    var Tween = createjs.Tween;
    var Ease = createjs.Ease;

    var noop = function(){};
    var Slideshow = $g.Slideshow;

    var STATES = Slideshow.STATES;
    var UNSTARTED = STATES.UNSTARTED;
    var PLAYING = STATES.PLAYING;
    var PAUSED = STATES.PAUSED;
    var COMPLETED = STATES.COMPLETED;

    function CenterBtn(slideshow) {
        var me = this;
        var parent = me.parent;
        var btnPause = me.btnPause;
        var btnReplay = me.btnReplay;
        var btnPlay = me.btnPlay;

        this.show = function(after) {
            parent.addChild(me);
            Tween.get(me)
                    .to({alpha: 1}, 750, Ease.quadOut)
                    .call(after||noop);

        };

        this.hide = function(after) {
            Tween.get(me)
                    .to({alpha: 0}, 750, Ease.quadIn)
                    .call(function() {
                        parent.removeChild(me);
                        (after||noop)();
                    });
        };

        this.update = function() {
            var e = slideshow.etat;
            btnPause.visible = e===PLAYING;
            btnPlay.visible = e===UNSTARTED||e===PAUSED;
            btnReplay.visible = e===COMPLETED;
        };

        function click() {
            var e = slideshow.etat;
            if (e===COMPLETED) {
                slideshow.replay();
            } else if (e===PAUSED) {
                slideshow.etat=PLAYING;
            } else if (e===PLAYING) {
                slideshow.etat=PAUSED;
            }
        }

        function init() {
            parent.removeChild(me);
            me.addEventListener("click", click);
        }

        init();
    }

    $g.CenterBtn = CenterBtn;

})(PVPGEngine, createjs);
